<template>
  <v-btn
    :to="to"
    class="padding"
    fixed
    bottom
    light
    round
    large
    color="white"
    >{{ text }}</v-btn
  >
</template>

<script>
export default {
  props: ["to", "text"]
};
</script>

<style>
.padding {
  padding-top: 29px;
  padding-bottom: 29px;
}
</style>
